import type { GridFields } from 'lib-node-question-builder';
import { formIs, formIsNot } from 'lib-node-question-builder/utils';

import { COUNTRY_LABEL_VALUE_ARRAY } from '~/common/constants/countries';
import { US_STATES_SHORT_OPTIONS_ARRAY } from '~/common/constants/us-states';
import { READONLY_CONDITION } from '~/pages/Loan1003DataGrids/common/utils/utils';

import type { AddressInfoData } from '../../../types';

export function createCommonAddressTemplate(
  prefix: string,
  isMailingAddress = false,
): GridFields<AddressInfoData['formData'], unknown>[] {
  const countryFieldName = `${prefix}.country`;
  const addressFieldPrefix = `${prefix}${isMailingAddress ? '' : '.borrowerAddress'}`;

  return [
    {
      elementType: 'question',
      type: 'text',
      span: 3,
      name: `${addressFieldPrefix}.addressLine1`,
      label: 'Address Line 1',
      placeholder: 'Address Line 1',
      rules: {
        required: true,
      },
      conditions: {
        isDisabled: READONLY_CONDITION,
      },
    },
    {
      elementType: 'question',
      type: 'text',
      span: 1,
      name: `${addressFieldPrefix}.unit`,
      placeholder: 'Unit #',
      label: 'Unit #',
      conditions: {
        isDisabled: READONLY_CONDITION,
      },
    },
    {
      elementType: 'question',
      type: 'text',
      span: 2,
      name: `${addressFieldPrefix}.city`,
      label: 'City',
      placeholder: 'City',
      rules: {
        required: true,
      },
      conditions: {
        isDisabled: READONLY_CONDITION,
      },
    },
    {
      id: `${addressFieldPrefix}.state.us`,
      elementType: 'question',
      type: 'select',
      span: 1,
      name: `${addressFieldPrefix}.state`,
      label: 'State',
      placeholder: 'Select State',
      options: US_STATES_SHORT_OPTIONS_ARRAY,
      rules: {
        required: true,
      },
      conditions: {
        isVisible: formIs(countryFieldName, 'US'),
        isDisabled: READONLY_CONDITION,
      },
    },
    {
      id: `${addressFieldPrefix}.state.nonUs`,
      elementType: 'question',
      type: 'text',
      span: 1,
      name: `${addressFieldPrefix}.state`,
      label: 'State',
      placeholder: 'State/Province/Region',
      rules: {
        required: true,
      },
      conditions: {
        isVisible: formIsNot(countryFieldName, 'US'),
        isDisabled: READONLY_CONDITION,
      },
    },
    {
      id: `${addressFieldPrefix}.zipCode.us`,
      elementType: 'question',
      type: 'text',
      span: 1,
      name: `${addressFieldPrefix}.zipCode`,
      label: 'Zip Code',
      placeholder: 'Zip Code',
      rules: {
        required: true,
      },
      conditions: {
        isVisible: formIs(countryFieldName, 'US'),
        isDisabled: READONLY_CONDITION,
      },
    },
    {
      id: `${addressFieldPrefix}.zipCode.nonUs`,
      elementType: 'question',
      type: 'text',
      span: 1,
      name: `${addressFieldPrefix}.zipCode`,
      label: 'Postal Code',
      placeholder: 'Postal Code',
      rules: {
        required: true,
      },
      conditions: {
        isVisible: formIsNot(countryFieldName, 'US'),
        isDisabled: READONLY_CONDITION,
      },
    },
    {
      elementType: 'question',
      type: 'select',
      name: countryFieldName,
      label: 'Country',
      placeholder: 'Select Country',
      options: COUNTRY_LABEL_VALUE_ARRAY,
      span: 2,
      rules: {
        required: true,
      },
      conditions: {
        isDisabled: READONLY_CONDITION,
      },
    },
  ];
}
